import { z } from 'zod'

export const addressSchema = z.object({
  line1: z.string(),
  city: z.string(),
  postcode: z.string(),
  country: z.string().optional(),
  type: z.string(),
})

export type Address = z.infer<typeof addressSchema>

export const memberSchema = z.object({
  id: z.number(),
  mvneId: z.string(),
  title: z.string().optional(),
  originalMemberName: z.string(),
  memberName: z.string(),
  email: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  alternativePhoneNumber: z.string().optional(),
  hasActiveSim: z.boolean(),
  msisdn: z.string().optional(),
  tcVersion: z.number(),
  birthDate: z.string().optional(),
  memberSince: z.string(),
  notifyPromotions: z.boolean(),
  marketingOptIn: z.boolean(),
  marketingPrefsServicePlus: z.boolean(),
  marketingPrefsProducts: z.boolean(),
  marketingPrefs3PartiesInternal: z.boolean(),
  marketingPrefs3PartiesExternal: z.boolean(),
  memberNameConfirmed: z.boolean(),
  addresses: z.array(addressSchema),
  hasMfa: z.boolean(),
  marketingPrefsPostal: z.boolean(),
  lastLoginTime: z.string(),
})

export type Root = z.infer<typeof memberSchema>
